export const OPEN = 'OPEN';

export const CLOSE = 'CLOSE';

const open = () => {
    return {
        type: OPEN,
    };
};

const close = () => {
    return {
        type: CLOSE,
    };
};

const intlInitialState = {
    show: false
};

const reducer = (state = intlInitialState, action) => {
    switch (action.type) {
        case OPEN:
            return { show: true };
        case CLOSE:
            return { show: false };
        default:
            return state;
    }
};

export default {
    reducer,
    actions: { open, close},
    intlInitialState
};